const isProd = window.location.hostname.includes('portal.foedus-eoeo.eu') || window.location.hostname.includes('auth.foedus-eoeo.eu');

export const authConfig = isProd
	? {
		domain: 'auth.foedus-eoeo.eu',
		clientId: '6hr4kltfrebl05qutgdqunhn10',
		responseType: 'code',
		redirectSignInUri: 'https://portal.foedus-eoeo.eu/simplifyworks/cognito/callback',
		redirectSignOutUri: 'https://portal.foedus-eoeo.eu',
		scopes: ['openid', 'email', 'profile'],
		region: 'eu-central-1',
		userPoolId: 'eu-central-1_IChNBBxKn'
	}
	: {
		domain: 'auth.staging.foedus-eoeo.eu',
		clientId: '1n6482ifreearneirpf3909t35',
		responseType: 'code',
		redirectSignInUri: 'https://staging.foedus-eoeo.eu/simplifyworks/cognito/callback',
		redirectSignOutUri: 'https://staging.foedus-eoeo.eu',
		scopes: ['openid', 'email', 'profile'],
		region: 'eu-central-1',
		userPoolId: 'eu-central-1_W4tyLNh1O'
	};
